module.exports = __webpack_public_path__ + "img/16.7391cd88.jpg";